import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrGuideFlagType.ts
var t = () => e("guideFlagType");
//#endregion
export { t as useTrGuideFlagType };
